import noop from 'lodash/noop';
import styled from 'styled-components';
import { body2, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { UNSUBSCRIBED_CHANNELS, UNSUBSCRIBED_MESSAGE_TYPES } from 'utils/fieldConstants';
import { FilterInputsList } from '../../FilterInputsList';
import { Query } from '../../FilterInputsList/FilterInputsList.types';
import { EventAndSearchQueryValidationErrors } from '../types';

type PropertyChangedRuleProps = {
  initialQueries: Query[];
  query: Partial<Query>;
  isDisabled: boolean;
  onSearchQueriesUpdate?: (newQueries: Partial<Query>[]) => void;
  errors?: EventAndSearchQueryValidationErrors;
};

const StyledContainer = styled.div`
  ${body2}
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

const StyledDescriptor = styled.div`
  width: ${pxToRem(124)};
  margin-right: ${spacing.base};
  display: flex;
  justify-content: flex-end;
`;

export const PropertyChangedRule = ({
  onSearchQueriesUpdate = noop,
  initialQueries,
  query,
  errors,
  isDisabled = false,
}: PropertyChangedRuleProps) => {
  return query ? (
    <StyledContainer data-test="ruleblock-property-changed-rule">
      <StyledDescriptor>Property changes</StyledDescriptor>
      <FilterInputsList
        initialQueries={initialQueries}
        dataType="user"
        trigger=""
        queries={[query]}
        onSearchQueriesUpdate={onSearchQueriesUpdate}
        canAddFilter={false}
        canDelete={false} // deleting property change rules don't make sense when there's only one per rule block
        NestComponent={null}
        queriesErrors={errors?.searchQuery?.searchQueries}
        isDisabled={isDisabled}
        isPropertyChanges={true}
        propertyMapDisallowedIds={[UNSUBSCRIBED_MESSAGE_TYPES, UNSUBSCRIBED_CHANNELS]} // for property changed events, we want to remove these properties from the dropdown.
      />
    </StyledContainer>
  ) : null;
};
